import { QueryClient } from '@tanstack/react-query';
import { clearStoredAuth } from './auth';

const PARTNER_SESSION_STORAGE_KEYS = [
  'partnerMode',
  'dismissedPendingChanges',
  'dontShowFreePlanModal',
] as const;

/** Clears auth tokens and all React Query cache (call on logout and before login). */
export function resetApplicationSession(queryClient: QueryClient) {
  clearStoredAuth();
  queryClient.clear();
  for (const key of PARTNER_SESSION_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60, // 1 minute
    },
    mutations: {
      retry: 0,
    },
  },
});
